import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptEvent } from "../adapters/adaptEvents";

const fetchEvent = async (id: number) => {
	const response = await cmsClient.get<IEvent>(`/homepage/admin/events/${id}/`);

	return response.data;
};

const useEvent = (id: number) => {
	const query = useQuery(["event", id], () => fetchEvent(id), {
		enabled: id > 0,
		select: adaptEvent
	});

	return query;
};

export default useEvent;
